import { Injectable, signal } from "@angular/core";
import { ReplaySubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FooterService {
  private _showFooter = new ReplaySubject<boolean>(1);
  isPaginationFinished = signal<boolean>(false);

  constructor() {}

  public getShowFooter() {
    return this._showFooter.asObservable();
  }

  public setShowFooter(showFooter: boolean) {
    this._showFooter.next(showFooter);
  }
}
